import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const About = () => {
  return (
    <div className="flex min-h-screen flex-col justify-between">
      <Header />
      <section className="relative" style={{}}>
        <div className="container">
          <div className="">
            <img
              className="bg-blue-800 absolute inset-0 h-full w-full object-cover object-center"
              src={require("../assets/images/background2.jpg")}
              alt=""
            />
            <div
              className="popoppins-events-none absolute left-0 top-0 h-full w-full"
              style={{
                background:
                  "linear-gradient(180deg, rgba(17, 23, 41, 0.6) 0%, rgba(32, 41, 58, 0.1) 100%)",
              }}
            ></div>
            <div className="relative flex min-h-[27rem] items-center md:min-h-[25.5rem]">
              <div className="items-center flex w-full flex-col">
                <h1 className="uppercase font-oswald break-words text-5xl md:text-4xl font-medium mb-4 text-white text-center">
                  WHAT IS THE poppinsNET OF THINGS?
                </h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-gray-100 py-16 md:py-24" style={{}}>
        <div className="container">
          <div className="">
            <div className="mx-auto max-w-[54.5rem] text-center md:text-xl">
              <div className="text-wrap">
                <p>
                  The poppinsnet of Things (IoT) refers to a network of
                  connected objects or devices. IoT technologies make it
                  possible to collect, transfer, and exchange relevant data
                  between those devices in real time without human touch.
                </p>
                <p>
                  {" "}
                  <br />{" "}
                </p>
                <p>
                  Combined with machine learning and AI, the poppinsnet of
                  Things enables devices to analyse and act on the collected
                  information, facilitating everyday tasks for people and
                  boosting efficiency for businesses.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="my-16 md:my-24">
        <div className="container">
          {/* Title and Description */}
          <div className="mb-12 text-center space-y-4">
            <h2 className="uppercase font-oswald text-2xl md:text-3xl font-medium text-blue-800">
              HOW DO IOT TECHNOLOGIES WORK?
            </h2>
            <p className="font-poppins text-xl font-normal mx-auto max-w-[54.5rem]">
              The word “things” in IoT refers to physical objects — from
              everyday household gadgets to industrial machines. These are
              connected to the network to collect and share data. Let's look at
              how IoT works in more detail.
            </p>
          </div>

          {/* Mobile: horizontal scroll cards */}
          <div className="md:hidden">
            <div className="overflow-x-auto flex-col snap-x gap-4 scroll-pl-4 pb-4">
              <div className="min-w-[90%] snap-start p-4 ">
                <img
                  src={require("../assets/images/IoT-technologies_diagram.png")}
                  alt="Gathering"
                  className="w-full h-auto mb-4"
                />
                <h4 className="uppercase font-oswald text-xl font-medium text-blue-800 mb-2">
                  Gathering
                </h4>
                <p className="text-base font-poppins">
                  IoT devices are equipped with various embedded solutions and
                  technologies, such as sensors, GPS modules, cameras, and
                  others. These help collect data on usage and conditions. For
                  example, your smartwatch may have sensors that measure heart
                  rate, movement, temperature, and more.
                </p>
              </div>

              <div className="min-w-[90%] snap-start p-4">
                <h4 className="uppercase font-oswald text-xl font-medium text-blue-800 mb-2">
                  Transmitting
                </h4>
                <p className="text-base font-poppins">
                  Before a user can view the data, it needs to be sent to a
                  server. IoT devices use wireless (Bluetooth, Wi-Fi, GSM, LTE)
                  or wired (Ethernet, CAN, fiber optics) technologies to
                  transmit this data.
                </p>
              </div>

              <div className="min-w-[90%] snap-start p-4 ">
                <h4 className="uppercase font-oswald text-xl font-medium text-blue-800 mb-2">
                  Processing
                </h4>
                <p className="text-base font-poppins">
                  Once received in the server or cloud, the data is processed —
                  classified, sorted, or calculated — transforming raw data into
                  useful insights. AI/ML can also analyze it and send commands
                  back to IoT devices for autonomous actions.
                </p>
              </div>

              <div className="min-w-[90%] snap-start p-4 ">
                <h4 className="uppercase font-oswald text-xl font-medium text-blue-800 mb-2">
                  Visualising
                </h4>
                <p className="text-base font-poppins">
                  The processed data is displayed via a graphical user interface
                  — a mobile app, desktop app, or web dashboard — allowing users
                  to view insights and control their IoT devices.
                </p>
              </div>
            </div>
          </div>

          {/* Desktop: image and 4-column grid */}
          <div className="hidden md:block">
            <img
              src={require("../assets/images/IoT-technologies_diagram.png")}
              alt="IoT Process Diagram"
              className="rounded-lg mb-8 w-full"
            />
            <div className="grid grid-cols-4 gap-6">
              <div>
                <h4 className="uppercase font-oswald text-xl font-medium text-blue-800 mb-2">
                  Gathering
                </h4>
                <p className="text-base font-poppins">
                  IoT devices are equipped with various embedded solutions and
                  technologies, such as sensors, GPS modules, cameras, and
                  others. These help collect data on usage and conditions. For
                  example, your smartwatch may have sensors that measure heart
                  rate, movement, temperature, and more.
                </p>
              </div>

              <div>
                <h4 className="uppercase font-oswald text-xl font-medium text-blue-800 mb-2">
                  Transmitting
                </h4>
                <p className="text-base font-poppins">
                  Before a user can view the data, it needs to be sent to a
                  server. IoT devices use wireless (Bluetooth, Wi-Fi, GSM, LTE)
                  or wired (Ethernet, CAN, fiber optics) technologies to
                  transmit this data.
                </p>
              </div>

              <div>
                <h4 className="uppercase font-oswald text-xl font-medium text-blue-800 mb-2">
                  Processing
                </h4>
                <p className="text-base font-poppins">
                  Once received in the server or cloud, the data is processed —
                  classified, sorted, or calculated — transforming raw data into
                  useful insights. AI/ML can also analyze it and send commands
                  back to IoT devices for autonomous actions.
                </p>
              </div>

              <div>
                <h4 className="uppercase font-oswald text-xl font-medium text-blue-800 mb-2">
                  Visualising
                </h4>
                <p className="text-base font-poppins">
                  The processed data is displayed via a graphical user interface
                  — a mobile app, desktop app, or web dashboard — allowing users
                  to view insights and control their IoT devices.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="my-16 md:my-24">
        <div className="container">
          <div className="mx-auto mb-6 max-w-[54.5rem] space-y-4 text-center md:mb-12">
            <h2 className="uppercase font-oswald break-words text-3xl md:text-2xl font-medium text-blue-800">
              HOW NYIRENDAS STARTED IN IOT
            </h2>
            <div className="quill-content">
              <p>
                The journey of Nyirendas into the world of IoT started back in
                the 2020 when IOT (Internet of Things) technologies
                were widely used to capture and record data. As chips and
                devices got smaller and the world started transitioning to
                wireless communication technologies, Nyirendas embarked on the
                path to becoming a leader in producing unique IoT solutions.
              </p>
            </div>
          </div>

          <div className="pl-3 xl:pl-[8.25rem] xl:pr-[7rem]">
            {/* Timeline Items */}
            {[
              {
                year: "Early 2020s",
                text: [
                  "Nyirendas launched a successful water meter project. The purpose of this IoT device was to control external sensors and retrieve data from them to make corresponding metering actions.",
                  "Then, the first prepaid water meter NCLV12 came to light, marking the beginning of Nyirendas's metering business niche.",
                ],
                image: require("../assets/images/about/1.jpg"),
                alt: "TBOXN12GPS",
              },
              {
                year: "2021",
                text: [
                  "We produced Nyirendas's first Card prepaid water meter IoT devices with DTBi - TM2. It was not only intended for easy use equipment but also worked as an modest technology for different agencies.",
                ],
                image: require("../assets/images/about/2.jpg"),
                alt: "TM2",
              },
              {
                year: "2022",
                text: [
                  "Nyirendas entered the personal and asset tracking business niche by introducing the GH3000 device. Its function was to quickly transmit the user's location and call for help in an emergency.",
                ],
                image: require("../assets/images/about/3.jpg"),
                alt: "GH3000 device",
              },
              {
                year: "2023",
                text: [
                  "To give even more value to our clients, we launched the FOTA configuration tool, providing sophisticated remote device management.",
                ],
                image: require("../assets/images/about/6.jpeg"),
                alt: "FOTA configuration tool",
              },
              {
                year: "2024",
                text: [
                  "Combining big data and excellent user experience, we started the Easy Key to IoT campaign. Since 2016, every device developed by Nyirendas has ensured an easily understandable user interface, allowing for effective remote management.",
                ],
                image: require("../assets/images/about/5.jpeg"),
                alt: "Easy Key to IoT",
                link: {
                  href: "#",
                  label: "Learn Nyirenda's history",
                },
              },
            ].map((item, index) => (
              <div
                key={index}
                className="relative flex gap-5 md:justify-center mb-16"
              >
                {/* Timeline line + dot */}
                <div className="flex flex-col items-center">
                  <div className="h-8 w-2 bg-gray-400 duration-200 time-frame-bubble-active" />
                  <div className="w-[0.125rem] grow bg-gray-400 relative">
                    <div
                      className="absolute w-[0.125rem] bg-blue-800"
                      style={{
                        height: "100%",
                        maxHeight: index === 4 ? "335px" : "399px",
                      }}
                    />
                  </div>
                </div>

                {/* Content + Image */}
                <div className="flex flex-col md:flex-row md:gap-[8.5rem] md:pb-16 w-full">
                  {/* Text */}
                  <div className="w-full md:max-w-[22.5rem]">
                    <p className="font-poppins break-words text-xl md:text-lg font-normal mb-3 pt-1 text-blue-800 md:pt-0">
                      {item.year}
                    </p>
                    <div className="quill-content space-y-3">
                      {item.text.map((line, i) => (
                        <p key={i}>{line}</p>
                      ))}
                      {item.link && (
                        <p>
                          <a
                            href={item.link.href}
                            className="relative inline rounded-sm text-blue-600 ring-blue-600 ring-offset-2 ring-offset-white focus:outline-none focus-visible:ring-2 active:outline-none before:absolute before:right-0 before:bottom-0 before:h-px before:w-0 before:bg-blue-600 before:duration-200 before:hover:left-0 hover:before:w-full"
                          >
                            {item.link.label}
                          </a>
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Image */}
                  <div className="mt-6 md:mt-0">
                    <img
                      className="rounded-lg w-full max-w-[480px] md:max-w-[500px] h-auto object-cover shadow-lg"
                      src={item.image}
                      alt={item.alt}
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
